import type { Logger } from "@expert/logging";

import { HTTPError } from "ky";

import { getRootDispatcher } from "@/analytics";

import type { Declination } from "../types";

import { getSalesApiClient } from "./api";

export const postDeclination = async (logger: Logger, declination: Declination) => {
    const childLogger = logger.child({ module: "declination", productOfferId: declination.productOfferId });
    try {
        const salesApi = getSalesApiClient();
        const result = await salesApi.post("v2/declination", { json: declination }).json<boolean>();

        void getRootDispatcher().dispatchBusinessEvent("PostDeclination", {
            result,
            StatusOrigin: "ASP",
        });
        childLogger.info({ result }, "Declination successful");
        return result;
    } catch (error: unknown) {
        if (error instanceof HTTPError) {
            void getRootDispatcher().dispatchBusinessEvent("DeclinationError", {
                Status: "LAMBDA_ERROR",
                Error: error,
            });
        }
        childLogger.warn({ error }, "Declination failure");
        return false;
    }
};
